import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/brand";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name || "trade partner"}`);
      if (u.role === "admin") navigate("/admin");
      else if (u.status === "approved") navigate("/portal");
      else navigate("/portal/pending");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="mc-grain relative flex min-h-screen items-center justify-center bg-[#0B0C0E] px-4">
      <div className="relative w-full max-w-md rounded-3xl border border-[#2A2E39] bg-[#121418] p-8 shadow-2xl mc-rise">
        <Link to="/" className="flex items-center justify-center gap-3">
          <img src={LOGO_URL} alt="M&C Ireland" className="h-20 w-auto" />
        </Link>
        <h1 className="mt-6 text-center font-serif-display text-3xl font-bold text-slate-50">Trade Portal Login</h1>
        <p className="mt-2 text-center text-sm text-[#94A3B8]">Approved retailers & administrators</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-[#2A2E39] bg-[#0B0C0E] px-4 py-3 text-sm text-slate-100 placeholder:text-[#64748B] focus:border-[#D4AF37]/60 focus:outline-none" />
          <input data-testid="login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl border border-[#2A2E39] bg-[#0B0C0E] px-4 py-3 text-sm text-slate-100 placeholder:text-[#64748B] focus:border-[#D4AF37]/60 focus:outline-none" />
          <button disabled={loading} data-testid="login-submit-btn" className="mc-btn-gold w-full rounded-full px-6 py-3.5 text-base disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-[#94A3B8]">
          No account? <Link to="/apply" className="font-semibold text-[#D4AF37]">Apply for a trade account</Link>
        </div>
      </div>
    </div>
  );
}
